import ClientPagination from 'frontend/commons/ClientPagination';
import LoadSpinner from 'frontend/commons/spinner';
import { HOTELS_PAGE_FILTER_NAME, ROUTE_KEYS } from 'frontend/constants';
import { usePackageCard } from 'frontend/contexts/PackageCardContext';
import { useCallback, useMemo } from 'react';
import HotelInfoCard from './components/HotelInfoCard';

const { PAQUETE } = ROUTE_KEYS;

const itemsPerPage = 6;

const HotelsInfo = ({ containerRef }) => {
  const {
    filters,
    handleFilters,
    packageConfigurations,
    packageConfigurationsIsFetching,
    packageConfigurationsIsLoading,
    packageData: { totalNights, provider_id },
  } = usePackageCard();

  const startIndex = useMemo(
    () => ((filters?.[HOTELS_PAGE_FILTER_NAME]?.value ?? 1) - 1) * itemsPerPage,
    [filters],
  );
  const endIndex = useMemo(() => startIndex + itemsPerPage, [startIndex]);

  const totalPages = useMemo(
    () =>
      packageConfigurations?.hotelInformationList
        ? Math.ceil(packageConfigurations?.hotelInformationList.length / itemsPerPage)
        : undefined,
    [packageConfigurations?.hotelInformationList],
  );

  const currentHotels = useMemo(
    () =>
      packageConfigurations?.hotelInformationList
        ?.sort(
          (a, b) =>
            parseFloat(a.subtotal) +
            parseFloat(a.taxTotal) -
            (parseFloat(b.subtotal) + parseFloat(b.taxTotal)),
        )
        .slice(startIndex, endIndex),
    [packageConfigurations?.hotelInformationList, startIndex, endIndex],
  );

  const packageLink = useCallback((_hotel, packageConfigurationId) => {
    return `${PAQUETE}/${packageConfigurationId}`;
  }, []);

  const handleCurrentPage = useCallback(
    (value) => {
      if (containerRef.current) {
        const containerRect = containerRef.current.getBoundingClientRect();
        if (containerRect.top < 0 || containerRect.bottom > window.innerHeight) {
          containerRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
      handleFilters(HOTELS_PAGE_FILTER_NAME, value);
    },
    [handleFilters, containerRef],
  );

  return !!packageConfigurationsIsFetching || !!packageConfigurationsIsLoading ? (
    <LoadSpinner style={{ marginTop: 20, marginBottom: 20 }} />
  ) : (
    <div className="package-card__dynamic-content__wrapper__hotel-list">
      <div className="package-card__dynamic-content__wrapper__hotel-list__records">
        {currentHotels?.map(({ hotelInformation, totalManager, packageConfigurationId }) => (
          <HotelInfoCard
            hotelInformation={
              Array.isArray(hotelInformation) ? hotelInformation : [hotelInformation]
            }
            totalManager={totalManager}
            packageLink={packageLink}
            key={packageConfigurationId}
            totalNights={totalNights}
            packageConfigurationId={packageConfigurationId}
            providerId={provider_id}
          />
        ))}
      </div>
      <ClientPagination
        totalPages={totalPages}
        currentPage={filters?.[HOTELS_PAGE_FILTER_NAME]?.value ?? 1}
        handleCurrentPage={handleCurrentPage}
      />
    </div>
  );
};

export default HotelsInfo;
